import { useSearchParamState } from "hooks/useSearchParamState";
import type {
  ProjectScope,
  UseProjectScopeArgs,
  UseProjectScopeResult,
} from "./types";

const SCOPE_PARAM_KEY = "projectListScope";
const DEFAULT_SCOPE: ProjectScope = "organization";

const parseScope = (raw: string): ProjectScope =>
  raw === "all" ? "all" : "organization";

// Keep the default ("organization") out of the URL so a scoped view has a clean
// address; only "all" is serialized.
const serializeScope = (scope: ProjectScope): string =>
  scope === DEFAULT_SCOPE ? "" : scope;

export const useProjectScope = ({
  canScopeToOrganization,
  organizationId,
}: UseProjectScopeArgs): UseProjectScopeResult => {
  const [scope, setScope] = useSearchParamState<ProjectScope>({
    key: SCOPE_PARAM_KEY,
    defaultValue: DEFAULT_SCOPE,
    parse: parseScope,
    serialize: serializeScope,
    replace: true,
  });

  const organizationFilter =
    canScopeToOrganization && scope === "organization" && organizationId
      ? organizationId
      : undefined;

  return { scope, setScope, organizationFilter };
};
